<div *ngIf="!isMobile" class="desktop-view">
  <section class="container noentry-info" *ngIf="isShowError()">
    <h3 class="noentry-title">No entry found</h3>
    <p class="progress-suggestions suggest">Suggestions:</p>
    <ul class="noentry-info" class="msg_bullets" >
      <li>Check the spelling.</li>
      <li>Try searching with a protein or gene name rather than by a specific accession.</li>
      <li>
        Check whether your protein may be excluded for one of the reasons outlined in our <a class="faqlink" href="/faq">FAQs</a>.</li>
    </ul>
  </section>
  <section class="container" *ngIf="entryData && !isObjectEmpty(entryData)">
    <entry-page-header />
    <main class="tab-container">
      <mat-tab-group
        #tabs
        (selectedTabChange)="selectTab($event)"
        [selectedIndex]="selectedTab()"
        mat-stretch-tabs="false"
        mat-align-tabs="start"
      >
        <mat-tab label="Summary and Model Confidence">
          <ng-template matTabContent>
            <summary-tab />
          </ng-template>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <div class="no-data-tag" *ngIf="tedDomainData().length === 0">
              <div class="na">N/A</div>
            </div>
            <div>Domains</div>
          </ng-template>
          <ng-template matTabContent>
            <domains-tab></domains-tab>
          </ng-template>
        </mat-tab>

        <mat-tab label="Annotations">
          <ng-template matTabContent>
            <annotations-tab  />
          </ng-template>
        </mat-tab>
        <mat-tab label="Similar Proteins">
            <ng-template matTabContent> <similar-structures-tab *ngIf="isEntryDataAvailable" [accession]="accession" [afdb_accession]="afdb_accession" [uniprotAccession]="uniprotAccession" /> </ng-template>
        </mat-tab>
      </mat-tab-group>
    </main>

    <entry-page-footer [isEntryPage]="true" />
  </section>

  <section class="container" *ngIf="entryData && isObjectEmpty(entryData) && !isShowError()">
    <div style="text-align: center; margin: 90px 0">
      <img src="../../assets/img/loader.gif" />
    </div>
  </section>
</div>
<div *ngIf="isMobile" class="mobile-view">
  @if(currentMobileView() === MobileView.Overview){
  <overview-mobile> </overview-mobile>
  } @if(currentMobileView() === MobileView.Molstar){
  <molstar-mobile> </molstar-mobile>
  }
</div>
<div id="parent-molstar-container" #molstarParent>
  <div id="molstar-element" class="molstar-viewer" #molstarViewer></div>
</div>
